import PropTypes from 'prop-types';

import { InputAdornment, TextField } from '@mui/material';
import { SearchOff } from '@mui/icons-material';

const SearchTable = ({ handleSearch, disabled, searchParam }) => {
  return (
    <TextField
      sx={{
        width: 200,
      }}
      id='input-with-icon-textfield5'
      variant='outlined'
      size='small'
      placeholder='Search'
      onChange={handleSearch}
      disabled={disabled}
      value={searchParam}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchOff />
          </InputAdornment>
        ),
      }}
    />
  );
};

SearchTable.defaultProps = {
  disabled: true,
};

SearchTable.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SearchTable;
